import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Form, Input } from '@rocketseat/unform';
import { toast } from 'react-toastify';
import Select from 'react-select';
import api from '~/services/apiBearer';
import apiWSCOM from '~/services/apiWSCOM';

import { Container, Loader, Info } from './styles';

export default function Contestation() {
  const token = useSelector(state => state.auth.token);
  api.defaults.headers.Authorization = `Bearer ${token}`;
  const refSelect = null;
  // #region Attributes
  const property = useSelector(state => state.property.property);
  const [fullproperty, setFullproperty] = useState('');
  const [inspectionLink, setInspectionLink] = useState('');
  const userType = useSelector(state => state.user.profile.tipoCliente);

  const reference = property.contract || property.businessId;

  const [name, setName] = useState('');
  const [rooms, setRooms] = useState();
  const [selectedRoom, setSelectedRoom] = useState('');
  const [description, setDescription] = useState('');
  const [roomsDescription, setRoomsDescription] = useState([]);

  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );

  const CustomSelectStyle = {
    container: base => ({
      ...base,
      margin: '20px 0',
      '@media (min-width: 320px) and (max-width: 768px)': {
        width: '18rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '25px',
      },
    }),
    control: base => ({
      ...base,
      height: '50px',
      borderRadius: '10px',
    }),
    valueContainer: base => ({
      ...base,
      height: '50px',
      padding: '0 15px',
    }),
    singleValue: base => ({
      ...base,
      height: '65px',
      top: '100%',
    }),
  };
  // #endregion

  // #region Methods
  async function AddRoomDescription(selectedRoomVal) {
    if (!description || !description.length) return;

    let room = selectedRoomVal == null || typeof selectedRoomVal == "undefined" ? selectedRoom: selectedRoomVal;

    setRoomsDescription([
      ...roomsDescription,
      { room: room, description },
    ]);

    setSelectedRoom(null);
    setDescription('');
  }

  function getRoomLabel(roomid) {

    let returnLabel = ''
    rooms.forEach((obj,idx)=>{
      if (roomid == obj.value) {
        returnLabel = obj.label
      }
    })

    return returnLabel

  }

  useEffect(() => {
    const roomItem = roomsDescription.find(e => e.room === selectedRoom);

    api.get("/api/v1/WSListaImovel?referencia=" + property.reference).then(
      response => {
        setFullproperty(response.data.conteudo[0])
      },
      error => {
        toast.error('Erro interno, por favor tente novamente mais tarde.');
        console.error(error);
      }
    );

    //if (roomItem) setDescription(roomItem.description);
  }, [roomsDescription, selectedRoom]);

  useEffect(() => {
    if (!reference || reference === 0) return;

    const url =
      property.contract > 0
        ? `api/v1/WSVistoria?Contrato=${property.contract}`
        : `api/v1/WSVistoriaProprietario?referencia=${reference}`;

    api.get(url).then(
      response => {
        const { sucesso: success, conteudo: responseUrl } = response.data;

        if (success) {
          setInspectionLink(responseUrl[0].link);
        }
      },
      error => {
        toast.error('Erro interno, por favor tente novamente mais tarde.');
        console.error(error);
      }
    );

    api.get(`api/v1/WSComodosVistoria?Contrato=${reference}`).then(
      response => {
        const {
          sucesso: success,
          conteudo: content,
          mensagem: message,
        } = response.data;

        if (success) {
          setRooms(content);
        } else {
          console.error(message);
        }
      },
      error => {
        toast.error(
          'Erro interno ao carregar os cômodos, por favor tente novamente mais tarde.'
        );
        console.error(error);
      }
    );

    setLoader(false);
  }, [property.contract, reference]);

  async function handleSubmit() {
    
    if (selectedRoom == '' || description == '') {
      toast.warning('Necessário selecionar um cômodo e realizar uma descrição.');
      return;
    }

    setLoader(true);

    //AddRoomDescription();

    let franquiaEmail = property.email || 'apolar@apolar.com.br'

    let franquiasCustomMail = {}

    let useUserType = userType.length > 1 ? userType[0] :  userType

    franquiasCustomMail['Inquilino'] = {
      'Assessoria Imobiliária Cons.Laurindo Ltda':'contestacao@apolarcentroaluga.com.br',
      'Image Participações S/A Centro':'contestacao@apolarcentroaluga.com.br',
      'Image Participações S/A Araucária':'cristiane.blati@apolararaucariaaluga.com.br',
      'Mkj Imóveis Ltda':'cintia.maian@apolarpinhaisaluga.com.br',
      'Novo Sol Assessoria Imobiliária Ltda':'negociacao@apolarpersonnalite.com.br',
    }

    franquiasCustomMail['Proprietário'] = {
      'Assessoria Imobiliária Cons.Laurindo Ltda':'analise@apolarcentroaluga.com.br',
      'Image Participações S/A Centro':'analise@apolarcentroaluga.com.br',
      'Image Participações S/A Araucária':'cristiane.blati@apolararaucariaaluga.com.br',
      'Mkj Imóveis Ltda':'admdigital@apolarpinhaisaluga.com.br',
      'Novo Sol Assessoria Imobiliária Ltda':'admdigital@apolarpersonnalite.com.br',
    }

    if (typeof franquiasCustomMail[useUserType][fullproperty.nomeFranquia] != "undefined" ) {
      franquiaEmail = franquiasCustomMail[useUserType][fullproperty.nomeFranquia]
    }


    //TICKET 3632 -  Alteração de e-mail
    franquiaEmail = franquiaEmail == "cintia.maia@apolarpinhaisaluga.com.br" ? "adm@apolarpinhaisaluga.com.br" : franquiaEmail

    var EmailContent = `Nome do solicitante: ${name}<br /> Referencia do imóvel: ${property.reference}<br /> Descritivo:`    
    EmailContent += `Cômodo: ` + getRoomLabel(selectedRoom) + `, Descrição: ` + description + `<br />`;
    /*roomsDescription.forEach((obj,idx)=>{
      EmailContent += `Cômodo: ` + getRoomLabel(obj.room) + `, Descrição: ` + obj.description + `<br />`;
    })*/

    apiWSCOM
      .post('api/email', {
        Destinatario: franquiaEmail,
        Subject: 'Contestação de Vistoria - Ref: ' + property.reference,
        EmailBody: EmailContent,
      })
      .then(
        response => {
          const { sucesso: success, mensagem: message } = response.data;

          if (success) {
            toast.success(
              'Sua solicitação de Contestação de vistoria foi enviada com sucesso! Nossa equipe irá analisá-la e entraremos em contato com você.'
            );
            setSelectedRoom(null);
            setDescription('');
            setRoomsDescription([]);
          } else {
            console.error(message);
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }
  // #endregion

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <Info>
        <h1>Contestação de Vistoria</h1>

        <div>
          <span>Ref.: {property.reference}</span>
          {property.contract ? (
            <span>Contrato: {reference}</span>
          ) : (
            <span>Referência: {reference}</span>
          )}

          <span>{property.address}</span>
        </div>
      </Info>

      <div className="centerText">
        <span>
          Preencha o formulário abaixo conforme as informações do seu laudo de
          vistoria.
        </span>

        {inspectionLink && (
          <button
            type="button"
            style={{ width: '200px' }}
            onClick={() => {
              window.open(inspectionLink);
            }}
          >
            Laudo de vistoria.
          </button>
        )}
      </div>

      <Form onSubmit={handleSubmit} autoComplete="off">
        <div>Nome</div>
        <Input
          name="name"
          value={name}
          onChange={e => {
            setName(e.target.value);
          }}
        />

        <Select
          placeholder="Selecione o cômodo"
          noOptionsMessage={() => 'Nenhum cômodo encontrado'}
          //value={null} /* <-- add this */
          options={rooms}
          ref={refSelect}
          onChange={item => {
            console.log(item.value)
            setSelectedRoom(item.value);
            //AddRoomDescription(item.value);
          }}
          styles={CustomSelectStyle}
        />

        <div>Descrição</div>
        <textarea
          name="description"
          value={description}
          onChange={e => {
            setDescription(e.target.value);
          }}
          maxLength={500}
        />

        <div className="buttonContainer">
          <button type="submit">Enviar</button>
        </div>
      </Form>
    </Container>
  );
}

